import {
    ANALYSIS_CHALLENGES_REQUESTED,
    ANALYSIS_CHALLENGES_SUCCEEDED,
    ANALYSIS_CHALLENGES_FAILED,
    ANALYSIS_RESEARCHERS_REQUESTED,
    ANALYSIS_RESEARCHERS_SUCCEEDED,
    ANALYSIS_RESEARCHERS_FAILED,
    ANALYSIS_SEGMENTS_REQUESTED,
    ANALYSIS_SEGMENTS_SUCCEEDED,
    ANALYSIS_SEGMENTS_FAILED,
    SEGMENTS_REPORT_REQUESTED,
    TOP_OBJECTS_REQUESTED,
    TOP_OBJECTS_SUCCEEDED,
    TOP_OBJECTS_FAILED,
    TOP_MATERIALS_REQUESTED,
    TOP_MATERIALS_SUCCEEDED,
    TOP_MATERIALS_FAILED,
    TOP_BRANDS_REQUESTED,
    TOP_BRANDS_SUCCEEDED,
    TOP_BRANDS_FAILED,
    SEGMENTS_REPORT_SUCCEEDED,
    SEGMENTS_REPORT_FAILED,
    OBJECTS_TAGS_REQUESTED,
    OBJECTS_TAGS_SUCCEEDED,
    OBJECTS_TAGS_FAILED,
    BRANDS_TAGS_REQUESTED,
    BRANDS_TAGS_SUCCEEDED,
    BRANDS_TAGS_FAILED,
    MATERIALS_TAGS_REQUESTED,
    MATERIALS_TAGS_SUCCEEDED,
    MATERIALS_TAGS_FAILED,
    HEATMAP_LITTERS_FAILED,
    HEATMAP_LITTERS_REQUESTED,
    HEATMAP_LITTERS_SUCCEEDED,
    SEGMENTS_INDEX_REQUESTED,
    SEGMENTS_INDEX_SUCCEEDED,
    SEGMENTS_INDEX_FAILED,
} from './constants';

export function AnalysisChallengesRequested() {
    return {
        type: ANALYSIS_CHALLENGES_REQUESTED,
    };
}

export function AnalysisChallengesSucceeded(challenges = []) {
    return {
        type: ANALYSIS_CHALLENGES_SUCCEEDED,
        challenges,
    };
}

export function AnalysisChallengesFailed(error) {
    return {
        type: ANALYSIS_CHALLENGES_FAILED,
        error,
    };
}

export function AnalysisResearchersRequested(selectedChallenges = []) {
    return {
        type: ANALYSIS_RESEARCHERS_REQUESTED,
        selectedChallenges,
    };
}

export function AnalysisResearchersSucceeded(researchers = []) {
    return {
        type: ANALYSIS_RESEARCHERS_SUCCEEDED,
        researchers,
    };
}

export function AnalysisResearchersFailed(error) {
    return {
        type: ANALYSIS_RESEARCHERS_FAILED,
        error,
    };
}

export function AnalysisSegmentsRequested(
    selectedChallenges = [],
    selectedResearchers = [],
) {
    return {
        type: ANALYSIS_SEGMENTS_REQUESTED,
        selectedChallenges,
        selectedResearchers,
    };
}

export function AnalysisSegmentsSucceeded(segments) {
    return {
        type: ANALYSIS_SEGMENTS_SUCCEEDED,
        segments,
    };
}

export function AnalysisSegmentsFailed(error) {
    return {
        type: ANALYSIS_SEGMENTS_FAILED,
        error,
    };
}

export function segmentReportRequested(
    selectedSegments = [],
    selectedChallenges = [],
    selectedResearchers = [],
    selectedSegmentsCompare = [],
    isComparisonActive = false,
) {
    return {
        type: SEGMENTS_REPORT_REQUESTED,
        selectedSegments,
        selectedChallenges,
        selectedResearchers,
        selectedSegmentsCompare,
        isComparisonActive,
    };
}

export function segmentReportSucceeded(selectedSegments = []) {
    return {
        type: SEGMENTS_REPORT_SUCCEEDED,
        selectedSegments,
    };
}

export function segmentReportFailed(error) {
    return {
        type: SEGMENTS_REPORT_FAILED,
        error,
    };
}

export function topObjectsRequested() {
    return {
        type: TOP_OBJECTS_REQUESTED,
    };
}

export function topObjectsSucceeded(topObjects, topObjectsCompare = []) {
    return {
        type: TOP_OBJECTS_SUCCEEDED,
        topObjects,
        topObjectsCompare,
    };
}

export function topObjectsFailed(error) {
    return {
        type: TOP_OBJECTS_FAILED,
        error,
    };
}

export function topMaterialsRequested() {
    return {
        type: TOP_MATERIALS_REQUESTED,
    };
}

export function topMaterialsSucceeded(topMaterials, topMaterialsCompare = []) {
    return {
        type: TOP_MATERIALS_SUCCEEDED,
        topMaterials,
        topMaterialsCompare,
    };
}

export function topMaterialsFailed(error) {
    return {
        type: TOP_MATERIALS_FAILED,
        error,
    };
}

export function topBrandsRequested() {
    return {
        type: TOP_BRANDS_REQUESTED,
    };
}

export function topBrandsSucceeded(topBrands, topBrandsCompare = []) {
    return {
        type: TOP_BRANDS_SUCCEEDED,
        topBrands,
        topBrandsCompare,
    };
}

export function topBrandsFailed(error) {
    return {
        type: TOP_BRANDS_FAILED,
        error,
    };
}

export function brandsTagsRequested() {
    return {
        type: BRANDS_TAGS_REQUESTED,
    };
}

export function materialsTagsRequested() {
    return {
        type: MATERIALS_TAGS_REQUESTED,
    };
}

export function objectsTagsRequested() {
    return {
        type: OBJECTS_TAGS_REQUESTED,
    };
}

export function brandsTagsSucceeded(brandsTags, brandsTagsCompare = []) {
    return {
        type: BRANDS_TAGS_SUCCEEDED,
        brandsTags,
        brandsTagsCompare,
    };
}

export function materialsTagsSucceeded(
    materialsTags,
    materialsTagsCompare = [],
) {
    return {
        type: MATERIALS_TAGS_SUCCEEDED,
        materialsTags,
        materialsTagsCompare,
    };
}

export function objectsTagsSucceeded(objectsTags, objectsTagsCompare = []) {
    return {
        type: OBJECTS_TAGS_SUCCEEDED,
        objectsTags,
        objectsTagsCompare,
    };
}

export function brandsTagsFailed(error) {
    return {
        type: BRANDS_TAGS_FAILED,
        error,
    };
}

export function materialsTagsFailed(error) {
    return {
        type: MATERIALS_TAGS_FAILED,
        error,
    };
}

export function objectsTagsFailed(error) {
    return {
        type: OBJECTS_TAGS_FAILED,
        error,
    };
}

export function heatmapLittersRequested(startDate) {
    return {
        type: HEATMAP_LITTERS_REQUESTED,
        startDate,
    };
}

export function heatmapLittersSucceeded(heatmapLitters) {
    return {
        type: HEATMAP_LITTERS_SUCCEEDED,
        heatmapLitters,
    };
}

export function heatmapLittersFailed(error) {
    return {
        type: HEATMAP_LITTERS_FAILED,
        error,
    };
}

export function segmentsIndexRequested() {
    return {
        type: SEGMENTS_INDEX_REQUESTED,
    };
}

export function segmentsIndexSucceeded(segmentsIndex) {
    return {
        type: SEGMENTS_INDEX_SUCCEEDED,
        segmentsIndex,
    };
}

export function segmentsIndexFailed(error) {
    return {
        type: SEGMENTS_INDEX_FAILED,
        error,
    };
}
